import React, { Component } from "react";
import { observer } from "mobx-react";
import { observable } from "mobx";
import HTMLContainer from "./HTMLContainer";
import HTMLElement from "./HTMLElement";
import Utils from "./../../utils/utils.js";
import Parser from "html-react-parser";
import domToReact from "html-react-parser/lib/dom-to-react";

// import HtmlToReact, { Parser } from "html-to-react";
// import utils from "html-to-react/libs/utils";

@observer
class Document extends Component {
  @observable properties = {};
  elements = [];
  styles = {};
  headStyle = null;
  loads = 0;
  handlers = [];

  constructor(props) {
    super(props);

    this.properties = [
      {
        type: "size",
        key: "SIZE",
        value: {
          width: this.props.width || 400,
          height: this.props.height || 600
        }
      },
      {
        type: "color",
        key: "BACKGROUND",
        value: this.props.background || "white"
      },
      {
        type: "string",
        key: "title",
        value: this.props.title || "Untilted document",
        visible: false
      }
    ];

    this.reftest = React.createRef();

    this.props.onRef(this);
  }

  componentDidUpdate() {
    this.handlers.forEach(h => h());
  }

  onUpdate(handler) {
    this.handlers.push(handler);
  }

  computed(cssText) {
    return this.parseCSSText(cssText);
  }

  computedStyleSheet(stylesheet) {
    const computed = {},
      s = stylesheet.split(/\{(.+?)\}/g).filter((e, i) => i % 2 === 0);
    s.forEach(_ => _.trim());
    stylesheet.match(/\{(.+?)\}/g).forEach((ct, i) => {
      computed[s[i].trim()] = ct;
    });
    return computed;
  }

  parseCSSText(cssText) {
    var cssTxt = cssText.replace(/\/\*(.|\s)*?\*\//g, " ").replace(/\s+/g, " ");
    var style = {},
      [, ruleName, rule] = cssTxt.match(/ ?(.*?) ?{([^}]*)}/) || [cssTxt];
    var cssToJs = s =>
      s.replace(/\W+\w/g, match => match.slice(-1).toUpperCase());
    var properties = rule
      .split(";")
      .map(o => o.split(":").map(x => x && x.trim()));
    for (var [property, value] of properties) style[cssToJs(property)] = value;
    return { cssText, ruleName, style };
  }

  addStyle(name, stylesheet) {
    let rules = stylesheet.split("}");
    let newRules = [];
    rules.slice(0, rules.length - 1).forEach(rule => {
      rule = (rule + "}").trim();
      let newRule = this.correctRule(rule);
      newRules.push(newRule);
    });
    stylesheet = newRules.join(" ");

    this.styles[name] = stylesheet;
    if (this.headStyle) {
      this.headStyle.innerHTML += stylesheet;
    }
  }

  correctRule(rule) {
    return rule.startsWith("body")
      ? ".document " + rule.substr(4, rule.length)
      : ".document " + rule;
  }

  addRule(stylesheet, rule) {
    let sh = this.styles[stylesheet];
    sh += " " + this.correctRule(rule);
    this.styles[stylesheet] = sh;
    this.updateInnerStyles();
  }

  updateInnerStyles() {
    this.headStyle.innerHTML = "";
    Object.values(this.styles).forEach(stylesheet => {
      this.headStyle.innerHTML += stylesheet + " ";
    });
  }

  handleElementClick(element, event) {
    this.getElementsAsArray().forEach(e => {
      e.hideTransformControls();
    });
    // element.getElement().style.border = '1px solid blue';
  }

  getElements() {
    return this.elements;
  }

  getElementById(id) {
    return this.refs[id];
  }

  getElementsAsArray() {
    console.log(this.refs);
    let arr = Object.values(this.refs);
    return arr.slice(2, arr.length);
  }

  hideAllTransformControls() {
    this.getElementsAsArray().forEach(e => e.hideTransformControls());
  }

  getElementAt(position) {
    let { x, y } = position;
    const elems = this.getElementsAsArray();
    let founds = elems.filter(el => {
      return Utils.is(x, y).in(el.getBoundingClientRect());
    });
    return founds.reduce((memo, item) => {
      return item.zIndex > memo.zIndex ? item : memo;
    }, founds[0]);
  }

  initCustomStyles() {
    const styleObj = document.createElement("style");
    styleObj.id = "customStyles";
    document.head.appendChild(styleObj);
    this.headStyle = document.getElementById("customStyles");
  }

  componentDidMount() {
    this.initCustomStyles();

    this.loadElementsFromHTML(
      '<!doctype html><meta charset=utf-8><title>Untilted Document</title><style>*{margin:0}body{margin:0;padding:0;background-color:#fff}.box{position:absolute;display:table;left:500px;top:500px;width:200px;height:200px;background-color:#00f;color:#fff;text-align:center;font-size:2em}.box1{position:absolute;display:table;left:300px;top:300px;width:50px;height:50px;background-color:red;color:#fff;text-align:center;font-size:2em}.box span{position: absolute;text-align:center}.text{position:absolute;left:400px;top:400px;color:#000;font-size:2em;line-height:1em;text-align:center;}</style><div class="box" id=test width=200px><span>Box</span></div><div class=box1 id=test1 width=200px><span>Box1</span></div><p class="text" id="lol">Hey i\'m a text!'
    );

    // console.log(this.refs.documentContainer.clientLeft);
  }

  getDocumentPosition() {
    var xPos = 0;
    var yPos = 0;
    let el = this.refs.documentContainer;
    xPos = el.offsetLeft - el.scrollLeft + el.clientLeft;
    yPos = el.offsetTop - el.scrollTop + el.clientTop;
    return {
      x: xPos,
      y: yPos
    };
  }

  clearElements() {
    this.elements = [];
    this.forceUpdate();
  }

  clearStyles() {
    this.headStyle.innerText = "";
  }

  loadElementsFromHTML(html) {
    this.clearElements();
    this.clearStyles();

    this.notifyPanel("updateDocument");

    const parser = new DOMParser();
    const fakeDoc = parser.parseFromString(html, "text/html");
    const head = fakeDoc.head;
    const body = fakeDoc.body;
    let iHtml = body.innerHTML;

    let styles = head.getElementsByTagName("style");
    Array.from(styles).forEach(s => {
      const style = s.innerText;
      this.addStyle("custom", style);
    });

    let self = this;

    // Transform all elements to htmlelements
    let id = 0;

    const parserOptions = {
      replace: function(node) {
        let { attribs, children } = node;

        if (!attribs) return;

        let props = {};

        if (node.parent)
          props = {
            parentId: node.parent.attribs.id
          };

        const type = children.length === 1 ? children[0].type : node.type;

        return (
          <HTMLElement
            type={type}
            tag={node.name}
            id={"element-" + id++}
            owner={self}
            onClick={self.handleElementClick.bind(self)}
            {...props}
            {...self.getCorrectAttrs(attribs)}
          >
            <node.name {...self.getCorrectAttrs(attribs)}>
              {domToReact(children, parserOptions)}
            </node.name>
          </HTMLElement>
        );
      }
    };

    let el = Parser(iHtml, parserOptions);
    (el.length ? el : [el]).forEach(el => this.addElement(el));
  }

  getCorrectAttrs(attrs) {
    let newAttrs = {};
    Object.keys(attrs).forEach(key => {
      const val = attrs[key];
      if (key === "class") key = "className";
      if (key === "for") key = "htmlFor";
      newAttrs[key] = val;
    });
    return newAttrs;
  }

  getElementsIn(bounds) {
    const arr = [];
    [].forEach.call(this.getElementsAsArray(), e => {
      var rect = e.getElement().getBoundingClientRect();

      if (
        rect.top + rect.height > bounds.top &&
        rect.left + rect.width > bounds.left &&
        rect.bottom - rect.height < bounds.top + bounds.height &&
        rect.right - rect.width < bounds.left + bounds.width
      ) {
        arr.push(e);
      }
    });
    return arr;
  }

  addRef(el) {
    this.refs[el.props.id] = el;
  }

  removeRef(el) {
    delete this.refs[el.props.id];
  }

  document(baseHTML) {
    let doc = null;
    if (baseHTML) {
      baseHTML = this.reformatHTML(baseHTML);
      const parser = new DOMParser();
      doc = parser.parseFromString(baseHTML, "text/html");
      // this.properties.title = doc.title;
      this.setProperty("title", doc.title);
    } else {
      doc = document.implementation.createHTMLDocument(this.properties.title);
    }
    return doc;
  }

  setDocument(doc) {
    if (this.documentContent) {
      this.documentContent.append(doc.documentElement);
      this.htmlDocument = this.documentContent.querySelector("html");
    }
  }

  registerPropertiesPanel(panel) {
    this.propertiesPanel = panel;
  }

  notifyPanel(evt, ...data) {
    if (!this.propertiesPanel) return;
    switch (evt) {
      case "selectionChanged":
        this.propertiesPanel.onSelectionChanged(data[0]);
        break;
      case "update":
        this.propertiesPanel.updateElementProperties();
        break;
      case "updateProperty":
        this.propertiesPanel.updatePropertyLine(data[0], data[1]);
        break;
      case "updateDocument":
        this.propertiesPanel.updateDocument();
        break;
      default:
        break;
    }
  }

  setProperty(key, value, type) {
    const prop = this.getProperty(key);
    if (!prop) {
      const newProp = {
        type: type || "string",
        key: key,
        value: value
      };
      this.properties.push(newProp);
    } else {
      prop.value = value;
      prop.type = type || prop.type;
    }
  }

  getProperty(key) {
    return this.properties.find(
      property => property.key.toLowerCase() === key.toLowerCase()
    );
  }

  addElement(htmlElement) {
    this.elements.push(htmlElement);
    this.forceUpdate();
  }

  getStyle() {
    const size = this.getProperty("size").value;
    return {
      width: size.width,
      height: size.height,
      boxShadow: "0px 0px 30px rgba(0, 0, 0, .16)",
      position: "absolute",
      left: "calc(50% - " + size.width / 2 + "px)",
      top: "calc(50% - " + size.height / 2 + "px)"
    };
  }

  // componentDidUpdate() {
  //   console.log("SALUT SA VA?");
  //   console.log(this.getProperty("size").value);
  // }

  childs(x, f, depth = 0) {
    if (!x || !x.props) return;

    f(x, depth);

    React.Children.forEach(x.props.children, x => {
      this.childs(x, f, depth + 1);
    });
  }

  getRefedElements() {
    const final = [];
    this.elements.forEach((el, index) => {
      final.push(
        React.cloneElement(el, {
          key: index,
          ref: el.props.id
        })
      );
    });
    return final;
  }

  render() {
    const size = this.getProperty("size").value;
    const styles = this.getStyle();
    return (
      <div>
        <span
          className="documentTitle"
          style={{
            position: "absolute",
            left: styles.left,
            top: "calc(50% - " + (size.height / 2 + 25) + "px)",
            zIndex: 1
          }}
        >
          {this.getProperty("title").value}
        </span>
        <div ref="documentContainer" className="document" style={styles}>
          <div id="documentContent" style={{ width: "100%", height: "100%" }}>
            <HTMLContainer
              ref="htmlcontainer"
              background={this.getProperty("background").value}
            >
              {this.getRefedElements()}
            </HTMLContainer>
          </div>
        </div>
      </div>
    );
  }
}

export default Document;



// WEBPACK FOOTER //
// ./src/components/document/document.js